module.exports = __webpack_public_path__ + "translations/en/forgotPassword.json";


//////////////////
// WEBPACK FOOTER
// ./translations/en/forgotPassword.json
// module id = ./translations/en/forgotPassword.json
// module chunks = 1